"use client";

import { usePathname } from "next/navigation";
import Link from "next/link";

const FullPrizeList = () => {
  // Rendered on /tournament/s{n}/{name}/purse, so the tournament base
  // path is the first three segments of the current URL.
  const pathname = usePathname() ?? "";
  const basePath = pathname.split("/").slice(0, 4).join("/");

  return (
    <div className="flex items-center justify-center mt-10 lg:mt-16">
      <Link
        href={`${basePath}/prize-list`}
        className={`text-tm-c-light bg-tm-c-brand
                text-[15px] 2xl:text-[17px] cursor-pointer text-center
                rounded-[6px] w-fit min-h-[40px] py-0 px-10 2xl:h-[45px]
                flex items-center justify-center
                disabled:opacity-30 disabled:cursor-default
              `}
      >
        See full prize list
      </Link>
    </div>
  );
};

export default FullPrizeList;
